<ng-content></ng-content>
<div data-qa="popup-modal-component" class="popup-modal" [class.inner-modal]="innerModal" (click)="closeModal.emit()">
</div>

